import { buildMaterialsReportPdf, type MaterialsReportPdfInput } from './materialsReportPdf';
import { loadImageDataUrl } from './dailyLogPdf';

/** Build the material-used/condemned report PDF and share it (mobile) or download it (desktop). */
export async function shareMaterialsReportPdf(input: Omit<MaterialsReportPdfInput, 'logoDataUrl'>): Promise<'shared' | 'downloaded'> {
  const logoDataUrl = await loadImageDataUrl('/logo.png');
  const blob = await buildMaterialsReportPdf({ ...input, logoDataUrl });

  const fileName = `Materials-Report_${input.from}_${input.to}.pdf`;
  const file = new File([blob], fileName, { type: 'application/pdf' });
  const nav = navigator as Navigator & { canShare?: (d: ShareData) => boolean };

  if (nav.canShare && nav.canShare({ files: [file] })) {
    await nav.share({ files: [file], title: 'Material Used & Condemned Report' });
    return 'shared';
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = fileName; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
  return 'downloaded';
}
